export const ROUTES = {
  home: "/",
  personalFinancing: "/personal-financing/",
  collateralFinancing: "/collateral-financing/",
  capitalInvestment: "/capital-investment/",
  enquiry: "/enquiry/",
  faq: "/faq/",
  contactUs: "/contact-us/",
};
